import { render, staticRenderFns } from "./BottomWaterUse.vue?vue&type=template&id=6caf7d46&scoped=true"
import script from "./BottomWaterUse.vue?vue&type=script&lang=js"
export * from "./BottomWaterUse.vue?vue&type=script&lang=js"
import style0 from "./BottomWaterUse.vue?vue&type=style&index=0&id=6caf7d46&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6caf7d46",
  null
  
)

export default component.exports